import React from 'react';
import { BoxIcon } from 'lucide-react';
interface StatsCardProps {
  title: string;
  value: string;
  change: string;
  trend: 'up' | 'down';
  icon: BoxIcon;
}
export function StatsCard({
  title,
  value,
  change,
  trend,
  icon: Icon
}: StatsCardProps) {
  return <div className="rounded-xl p-6 bg-card border border-border hover:shadow-md hover:bg-[#ededed]/20 transition-all" data-id="element-152">
      <div className="flex items-start justify-between mb-4" data-id="element-153">
        <div className="flex-1" data-id="element-154">
          <p className="text-sm font-medium text-muted-foreground" data-id="element-155">{title}</p>
        </div>
        <div className="h-10 w-10 rounded-lg bg-[#f88d3e]/10 flex items-center justify-center" data-id="element-156">
          <Icon className="h-5 w-5 text-[#f88d3e]" data-id="element-157" />
        </div>
      </div>
      <p className="text-3xl font-bold text-foreground mb-2" data-id="element-158">{value}</p>
      <p className="text-sm text-muted-foreground" data-id="element-159">{change}</p>
    </div>;
}